<ejs-sidebar id="stages-menu" #sidebarInstance type='Over' [width]='width' [position]='position'
             style="visibility: hidden" [enableGestures]="false" [showBackdrop]=true>

  <div class="offcanvas-close mt-n1 pr-5" style="float:right; padding: 48px;">
    <a href="javascript:;" class="btn btn-xs btn-icon btn-light btn-hover-primary" id="kt_quick_panel_close"
       (click)="closeSidebar()">
      <i class="ki ki-close icon-xs text-muted"></i>
    </a>
  </div>

  <div class='p-15'>
    <h2 *ngIf="!articleTypeInput">Add Article Type</h2>
    <h2 *ngIf="articleTypeInput">Update Article Type</h2>

    <form id="formId" [formGroup]="articleTypeForm" #formDir="ngForm" class="form-horizontal" novalidate=""
          style="margin-top: 16px;">


    <div class="form-group sf-outline-input mb-10">
      <ejs-textbox id="Article Stage_name" placeholder="Article Stage Name *" cssClass="e-filled"
                    floatLabelType="Auto" [(ngModel)]="article_type_name" [enabled]=false
                    (blur)="articleTypeForm.controls.article_stage_.markAsTouched()" [ngModelOptions]="{standalone: true}"
      ></ejs-textbox>
      </div>

      

      <div class="form-group sf-outline-input mb-10">
        <label>Filter Color</label>
        <input ejs-colorpicker id="inline-color-picker" type="color" [modeSwitcher]=false  [showButtons]=false
               formControlName="filter_color" placeholder="Filter Color" cssClass="e-filled"  />
        <div *ngIf="articleTypeForm.controls.filter_color.errors">
          <div
            *ngIf="articleTypeForm.controls.filter_color.errors.required && articleTypeForm.controls.filter_color.touched"
            class="e-error">
            Filter color is required.
          </div>
        </div>
      </div>

      <div class="form-group sf-outline-input mb-10">
        <label>Filter Text Color</label>
        <input ejs-colorpicker id="inline-color-picker-text" type="color" [modeSwitcher]=false  [showButtons]=false
               formControlName="filter_text_color" placeholder="Filter Color" cssClass="e-filled"  />
        <div *ngIf="articleTypeForm.controls.filter_text_color.errors">
          <div
            *ngIf="articleTypeForm.controls.filter_text_color.errors.required && articleTypeForm.controls.filter_text_color.touched"
            class="e-error">
            Filter text color is required.
          </div>
        </div>
      </div>


      <div class="form-group sf-outline-input mb-10">
        <ejs-textbox id="short_code" placeholder="Short Code *" cssClass="e-filled"
                     formControlName="short_code" floatLabelType="Auto"
                     (blur)="articleTypeForm.controls.short_code.markAsTouched()"
        ></ejs-textbox>
        <div *ngIf="articleTypeForm.controls.short_code.errors">
          <div
            *ngIf="articleTypeForm.controls.short_code.errors.required && articleTypeForm.controls.short_code.touched"
            class="e-error">
            Short Code is required.
          </div>
          <div *ngIf="articleTypeForm.controls.short_code.errors.maxlength && articleTypeForm.controls.short_code.touched"
               class="e-error">
            Short Code cannot be more than 6 characters
          </div>
        </div>
      </div>

      <div class="form-group sf-outline-input mb-10">

        <ejs-numerictextbox id="rank_order" #rankOrder
                  formControlName="rank_order" floatLabelType="Auto" strictMode="true" validateDecimalOnType="true" 
                  cssClass="e-filled" placeholder="Rank" format='n0' min="1" [max]="maxValue" 
                ></ejs-numerictextbox>
                <div *ngIf="articleTypeForm.controls.rank_order.errors">
                  <div
                    *ngIf="articleTypeForm.controls.rank_order.errors.required && articleTypeForm.controls.rank_order.touched"
                    class="e-error">
                    Rank is required.
                  </div>
                </div>
      </div>

      <div class="form-group sf-outline-input mb-10">
        <ejs-textbox id="description" [multiline]="true" placeholder="Description" cssClass="e-filled"
                     formControlName="description" floatLabelType="Auto"
                     (blur)="articleTypeForm.controls.description.markAsTouched()"
        ></ejs-textbox>
        <div *ngIf="articleTypeForm.controls.description.errors">
          <div *ngIf="articleTypeForm.controls.description.errors.maxlength && articleTypeForm.controls.description.touched"
               class="e-error">
            Descripton cannot be more than 200 characters
          </div>
        </div>
      </div>


      <div *ngIf="articleTypeForm.invalid" class="e-error">Please fill all fields</div>
      <div *ngIf="error$ | async as error" class="e-error">{{error.error.message}}</div>

      <div class="my-10 pb-20">
        <button id="resetbtn"
                class="btn btn-outline-secondary text-uppercase font-weight-bold px-15 py-5 float-right btn-block mb-5"
                type="button"
                data-ripple="true" (click)="clear()">Clear
        </button>
        <button *ngIf="!articleTypeInput" id="addSubmit"
                class="btn btn-primary text-uppercase font-weight-bold px-15 py-5 float-right btn-block" type="submit"
                (click)="onAddUpdateArticleType(articleTypeForm); articleTypeForm.markAllAsTouched()" [disabled]="formSent" data-ripple="true"> Add
          Article Type
        </button>
        <button *ngIf="articleTypeInput" id="updateSubmit"
                class="btn btn-primary text-uppercase font-weight-bold px-15 py-5 float-right btn-block" type="submit"
                (click)="onAddUpdateArticleType(articleTypeForm, true)" [disabled]="formSent" data-ripple="true">
          Update Article Type
        </button>
      </div>
    </form>
  </div>
</ejs-sidebar>

<ejs-dialog #clearModal [buttons]='dltButtons' header='Are you sure?' animationSettings='none' showCloseIcon='true'
            width='25%' [visible]='false'>
  <ng-template #content>
    <p>This action will clear all form fields.</p>
  </ng-template>
</ejs-dialog>
